import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const n = a((i, o) => /* @__PURE__ */ e.jsx(
  r,
  {
    ref: o,
    ...i,
    image: (l) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...l,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M30.866 17.985a4 4 0 0 0 0-3.97l-5.714-10A4 4 0 0 0 21.679 2H10.32a4 4 0 0 0-3.473 2.015l-5.714 10a4 4 0 0 0 0 3.97l5.714 10A4 4 0 0 0 10.321 30H21.68a4 4 0 0 0 3.473-2.015zM14.172 20h-1.74v-8.402h2.467l2.935 5.876v-5.876h1.734V20h-2.226l-3.17-6.252z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
n.displayName = "NiacinmideIcon";
export {
  n as NiacinmideIcon,
  n as default
};
//# sourceMappingURL=index.js.map
